<script setup lang="ts">
import FaceEmojiSadIcon from '@/assets/icons/FaceEmojiSadIcon.vue';
import FaceEmojiNeutralIcon from '@/assets/icons/FaceEmojiNeutralIcon.vue';
import FaceEmojiHappyIcon from '@/assets/icons/FaceEmojiHappyIcon.vue';
import FaceEmojiSuperSadIcon from '@/assets/icons/FaceEmojiSuperSadIcon.vue';
import FaceEmojiSuperHappyIcon from '@/assets/icons/FaceEmojiSuperHappyIcon.vue';

defineProps<{
  level?: number;
}>();
</script>

<template>
  <FaceEmojiSuperSadIcon v-if="level === 1" />
  <FaceEmojiSadIcon v-else-if="level === 2" />
  <FaceEmojiNeutralIcon v-else-if="level === 3" />
  <FaceEmojiHappyIcon v-else-if="level === 4" />
  <FaceEmojiSuperHappyIcon v-else-if="level === 5" />
  <FaceEmojiHappyIcon v-else />
</template>
